export type Character = "VAMPIRE" | "JIANGSHI" | "GUMIHO" | "MUMMY" | "ZOMBIE";

export const ALL_CHARACTERS: readonly Character[] = [
  "VAMPIRE",
  "JIANGSHI",
  "GUMIHO",
  "MUMMY",
  "ZOMBIE",
] as const;

export const CHARACTER_COUNT = 5;
